import React, { useEffect, useState } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { APIDataUrl, APITokenUrl } from "../../Utils/Utils";
import axios from "axios";
import KeywordTagsSelect from "./KeywordTagsSelect";

const KeywordFilterModal = ({
  setKeywordAddModal,
  setFeedBox,
  feedBox,
}) => {
  const [updatedTags, setUpdatedTags] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [economicTags, setEconomicTags] = useState([]);
  const [isEconomicTagsSelected, setIsEconomicTagsSelected] = useState(false);

  const style2 = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 3,
    borderRadius: "8px",
  };

  const handleSave = () => {
    setKeywordAddModal(false);

    let finalTags = [...selectedValues];

    if (isEconomicTagsSelected) {
      finalTags = Array.from(new Set([...selectedValues, ...economicTags]));
    }

    setFeedBox(finalTags);
  };

  useEffect(() => {
    if (feedBox?.length) {
      setSelectedValues(feedBox);
    }
  }, [feedBox]);

  const getContentFeed = () => {
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/get_news_tags`,
    };
    axios(options)
      .then((res) => {
        setUpdatedTags(res.data || []);
      })
      .catch((error) => {
        console.error("Error fetching tags", error);
      });
  };

  const getEconomicTags = () => {
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/get_economic_tags`,
    };
    axios(options)
      .then((res) => {
        setEconomicTags(res.data || []);
      })
      .catch((error) => {
        console.error("Error fetching tags", error);
      });
  };

  useEffect(() => {
    getContentFeed();
    getEconomicTags();
  }, []);

  const handleCheckboxChange = (e, item) => {
    if (e.target.checked) {
      setSelectedValues((prev) => [...prev, item]);
    } else {
      setSelectedValues((prev) => prev.filter((i) => i !== item));
    }
  };

  const handleEconomicTagsChange = (e) => {
    const checked = e.target.checked;
    setIsEconomicTagsSelected(checked);

    if (checked) {
      setSelectedValues((prev) =>
        Array.from(new Set([...prev, ...economicTags])),
      );
    } else {
      setSelectedValues((prev) =>
        prev.filter((tag) => !economicTags.includes(tag)),
      );
    }
  };

  return (
    <>
    <div className="vrufyerv keyword-news-modal">
      <Box sx={style2}>
        <div className="modal-head-heading-crossicon">
          <Typography
            variant="h6"
            component="h2"
            className="enetr-name-heading-modal keyw-ci-modal"
          >
            Search Keyword
          </Typography>
          <ClearIcon
            style={{ cursor: "pointer" }}
            onClick={() => setKeywordAddModal(false)}
          />
        </div>

        <div className="keywordFilter-dropdown">
          <KeywordTagsSelect
            formControlData={{
              value: "",
              handleChange: () => {},
              dataList: updatedTags,
              handleCheckboxChange,
              selectedData: selectedValues,
              checked: selectedValues,
              type: "checkbox",
              economicTags: economicTags,
              handleEconomicTagsChange,
              isEconomicTagsSelected: isEconomicTagsSelected,
            }}
            placeholder="Select Tags"
          />
        </div>

        <Stack>
          <div className="button-cancel-save-modal">
            <Button
              variant="outlined"
              className="cancel-button-modal"
              onClick={() => setKeywordAddModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className="save-button-modal"
              onClick={handleSave}
            >
              Save
            </Button>
          </div>
        </Stack>
      </Box>
    </div>
    </>
  );
};

export default KeywordFilterModal;
